
import { SiriusBaseComponent } from 'sirius-framework';
import { ElementRef, Renderer2, ViewChildren, QueryList, Component } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { InnerMenuOldProcessService } from '../../inner-menu-oldprocess.service';
import { CommonService } from '../../../shared/service/shared.service';
import { ProcessItem, OldProcessRequest } from '../../../shared/models/process.model';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan; değerler mevcut DB anahtarlarıyla uyumlu */
const OLDPROCESS_KEYS = {
  title1: 'oldProcess_Title1',
  title2: 'oldProcess_Title2',
  title3: 'oldProcess_Title3',
  startDate: 'oldProcess_StartDate',
  startWarning1: 'oldProcess_StartWarning1',
  startWarning2: 'oldProcess_StartWarning2',
  endDate: 'oldProcess_EndDate',
  endWarning1: 'oldProcess_EndWarning1',
  endWarning2: 'oldProcess_EndWarning2',
  carNo: 'oldProcess_CarNo',
  search: 'oldProcess_Search',
  firmReference: 'oldProcess_FirmReference',
  productNo: 'oldProcess_ProductNo',
  processType: 'oldProcess_ProcessType',
  totalAmount: 'oldProcess_TotalAmount',
  processStatus: 'oldProcess_ProcessStatus',
  detail: 'oldProcess_Detail',
  noRecords: 'oldProcess_NoRecords',
  backButton: 'oldProcess_BackButton',
  actionDetail: 'oldProcess_ActionDetail',
  processTypeValue1: 'oldProcess_ProcessTypeValue1',
  processTypeValue2: 'oldProcess_ProcessTypeValue2',
  statusText1: 'oldProcess_StatusText1',
  statusText2: 'oldProcess_StatusText2',
  statusText3: 'oldProcess_StatusText3',
  statusText4: 'oldProcess_StatusText4',
  statusText5: 'oldProcess_StatusText5',
  statusText6: 'oldProcess_StatusText6',
  statusText7: 'oldProcess_StatusText7',
  statusText9: 'oldProcess_StatusText9',
  amountCurrencySuffix: 'oldProcess_AmountCurrencySuffix',
};

@Component({
  selector: 'oldprocess',
  templateUrl: './oldprocess.component.html',
  styleUrls: ['./oldprocess.component.css']
})

export class OldProcessComponent extends SiriusBaseComponent<any> {
  @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;
  pageIndex: number;
  titleText: string = "";
  searchForm: FormGroup;
  searchResultData: ProcessItem[] = [];
  noResult: boolean = false;
  selectedProcess: ProcessItem;
  /* String Resource — Türkçe varsayılan, loadOldProcessResourceStrings ile DB’den güncellenir */
  oldProcess_Title1 = 'Geçmiş İşlemlerim';
  oldProcess_Title2 = 'İşlem Detayı';
  oldProcess_Title3 = 'İşlem Aksiyonları';
  oldProcess_StartDate = 'Başlangıç Tarihi';
  oldProcess_StartWarning1 = 'Başlangıç tarihi zorunludur.';
  oldProcess_StartWarning2 = 'Geçerli bir başlangıç tarihi giriniz.';
  oldProcess_EndDate = 'Bitiş Tarihi';
  oldProcess_EndWarning1 = 'Bitiş tarihi zorunludur.';
  oldProcess_EndWarning2 = 'Geçerli bir bitiş tarihi giriniz.';
  oldProcess_CarNo = 'Plaka No';
  oldProcess_Search = 'Ara';
  oldProcess_FirmReference = 'Referans No:';
  oldProcess_ProductNo = 'Plaka No:';
  oldProcess_ProcessType = 'İşlem Türü:';
  oldProcess_TotalAmount = 'Tutar:';
  oldProcess_ProcessStatus = 'İşlem Durumu:';
  oldProcess_Detail = 'Detay';
  oldProcess_NoRecords = 'Gösterilecek işlem bulunamadı.';
  oldProcess_BackButton = 'Geri';
  oldProcess_ActionDetail = 'Devam';
  oldProcess_ProcessTypeValue1 = 'SATIŞ';
  oldProcess_ProcessTypeValue2 = 'ALIŞ';
  oldProcess_StatusText1 = 'Beklemede';
  oldProcess_StatusText2 = 'Devam ediyor';
  oldProcess_StatusText3 = 'Onay bekliyor';
  oldProcess_StatusText4 = 'Tamamlandı';
  oldProcess_StatusText5 = 'İptal';
  oldProcess_StatusText6 = 'Reddedildi';
  oldProcess_StatusText7 = 'Süresi doldu';
  oldProcess_StatusText9 = 'Diğer';
  oldProcess_AmountCurrencySuffix = ' TL';
  constructor(private innerMenuOldProcessService: InnerMenuOldProcessService, private commonService: CommonService, private renderer: Renderer2) {
    super();
  }
  OnInit() {
    this.loadOldProcessResourceStrings();
    this.pageIndex = 0;
    this.titleText = this.oldProcess_Title1;
    this.commonService.selectedProcessDetail = null;
    this.commonService.selectedProcessAction = null;
    this.searchForm = new FormGroup({
      'startDate': new FormControl(null, [Validators.required, this.dateControl]),
      'endDate': new FormControl(null, [Validators.required, this.dateControl]),
      'carNo': new FormControl(null)
    });
    this.setDatePickers();
  }
  private loadOldProcessResourceStrings(): void {
    const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);

    this.oldProcess_Title1 = r(OLDPROCESS_KEYS.title1, this.oldProcess_Title1);
    this.oldProcess_Title2 = r(OLDPROCESS_KEYS.title2, this.oldProcess_Title2);
    this.oldProcess_Title3 = r(OLDPROCESS_KEYS.title3, this.oldProcess_Title3);
    this.oldProcess_StartDate = r(OLDPROCESS_KEYS.startDate, this.oldProcess_StartDate);
    this.oldProcess_StartWarning1 = r(OLDPROCESS_KEYS.startWarning1, this.oldProcess_StartWarning1);
    this.oldProcess_StartWarning2 = r(OLDPROCESS_KEYS.startWarning2, this.oldProcess_StartWarning2);
    this.oldProcess_EndDate = r(OLDPROCESS_KEYS.endDate, this.oldProcess_EndDate);
    this.oldProcess_EndWarning1 = r(OLDPROCESS_KEYS.endWarning1, this.oldProcess_EndWarning1);
    this.oldProcess_EndWarning2 = r(OLDPROCESS_KEYS.endWarning2, this.oldProcess_EndWarning2);
    this.oldProcess_CarNo = r(OLDPROCESS_KEYS.carNo, this.oldProcess_CarNo);
    this.oldProcess_Search = r(OLDPROCESS_KEYS.search, this.oldProcess_Search);
    this.oldProcess_FirmReference = r(OLDPROCESS_KEYS.firmReference, this.oldProcess_FirmReference);
    this.oldProcess_ProductNo = r(OLDPROCESS_KEYS.productNo, this.oldProcess_ProductNo);
    this.oldProcess_ProcessType = r(OLDPROCESS_KEYS.processType, this.oldProcess_ProcessType);
    this.oldProcess_TotalAmount = r(OLDPROCESS_KEYS.totalAmount, this.oldProcess_TotalAmount);
    this.oldProcess_ProcessStatus = r(OLDPROCESS_KEYS.processStatus, this.oldProcess_ProcessStatus);
    this.oldProcess_Detail = r(OLDPROCESS_KEYS.detail, this.oldProcess_Detail);
    this.oldProcess_NoRecords = r(OLDPROCESS_KEYS.noRecords, this.oldProcess_NoRecords);
    this.oldProcess_BackButton = r(OLDPROCESS_KEYS.backButton, this.oldProcess_BackButton);
    this.oldProcess_ActionDetail = r(OLDPROCESS_KEYS.actionDetail, this.oldProcess_ActionDetail);
    this.oldProcess_ProcessTypeValue1 = r(OLDPROCESS_KEYS.processTypeValue1, this.oldProcess_ProcessTypeValue1);
    this.oldProcess_ProcessTypeValue2 = r(OLDPROCESS_KEYS.processTypeValue2, this.oldProcess_ProcessTypeValue2);
    this.oldProcess_StatusText1 = r(OLDPROCESS_KEYS.statusText1, this.oldProcess_StatusText1);
    this.oldProcess_StatusText2 = r(OLDPROCESS_KEYS.statusText2, this.oldProcess_StatusText2);
    this.oldProcess_StatusText3 = r(OLDPROCESS_KEYS.statusText3, this.oldProcess_StatusText3);
    this.oldProcess_StatusText4 = r(OLDPROCESS_KEYS.statusText4, this.oldProcess_StatusText4);
    this.oldProcess_StatusText5 = r(OLDPROCESS_KEYS.statusText5, this.oldProcess_StatusText5);
    this.oldProcess_StatusText6 = r(OLDPROCESS_KEYS.statusText6, this.oldProcess_StatusText6);
    this.oldProcess_StatusText7 = r(OLDPROCESS_KEYS.statusText7, this.oldProcess_StatusText7);
    this.oldProcess_StatusText9 = r(OLDPROCESS_KEYS.statusText9, this.oldProcess_StatusText9);
    this.oldProcess_AmountCurrencySuffix = this.commonService.getStringResource(
      OLDPROCESS_KEYS.amountCurrencySuffix,
      this.oldProcess_AmountCurrencySuffix);
  }
  getStartWarningText() {
    if (this.searchForm.controls.startDate.invalid && this.searchForm.controls.startDate.touched) {
      if (this.searchForm.controls.startDate.errors['required']) {
        return this.oldProcess_StartWarning1;
      }
      else {
        return this.oldProcess_StartWarning2;
      }
    }
  }
  getEndWarningText() {
    if (this.searchForm.controls.endDate.invalid && this.searchForm.controls.endDate.touched) {
      if (this.searchForm.controls.endDate.errors['required']) {
        return this.oldProcess_EndWarning1;
      }
      else {
        return this.oldProcess_EndWarning2;
      }
    }
  }
  getTypeText(type) {
    return type == "S" ? this.oldProcess_ProcessTypeValue1 : this.oldProcess_ProcessTypeValue2;
  }
  getStatusText(status) {
    let text = "";
    switch (status) {
      case "1":
        text = this.oldProcess_StatusText1;
        break;
      case "2":
        text = this.oldProcess_StatusText2;
        break;
      case "3":
        text = this.oldProcess_StatusText3;
        break;
      case "4":
        text = this.oldProcess_StatusText4;
        break;
      case "5":
        text = this.oldProcess_StatusText5;
        break;
      case "6":
        text = this.oldProcess_StatusText6;
        break;
      case "7":
        text = this.oldProcess_StatusText7;
        break;
      case "9":
        text = this.oldProcess_StatusText9;
        break;
    }
    return text;
  }
  onSearchSubmit() {
    this.noResult = false;
    if (this.searchForm.controls.startDate.valid && this.searchForm.controls.endDate.valid) {
      var oldProcessRequest: OldProcessRequest = {
        StartDate: this.searchForm.controls.startDate.value.replace(/\//g, ""),
        EndDate: this.searchForm.controls.endDate.value.replace(/\//g, ""),
        CarNo: this.searchForm.controls.carNo.value
      }
      var promise = this.innerMenuOldProcessService.getUserOldProcess(this.dataService, oldProcessRequest).toPromise();
      promise.then((result) => {
        if (result != null && Array.isArray(result) && result.length > 0) {
          this.searchResultData = result as Array<ProcessItem>;
        }
        else {
          this.noResult = true;
          this.searchResultData = null;
        }
      });
    }
    else {
      this.searchForm.controls.startDate.markAsTouched();
      this.searchForm.controls.endDate.markAsTouched();
    }
  }
  goProcessDetail(index: number) {
    this.selectedProcess = this.searchResultData[index];
    this.pageIndex = this.pageIndex + 1;
  }
  elementTitleClicked(i: number) {
    var elementList = this.elementTitles.toArray();
    for (let j = 0; j < elementList.length; j++) {
      if (j == i) {
        if (elementList[j].nativeElement.children[0].classList.contains("open"))
        {
          this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
        }
        else {
          this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
        }
      }
      else {
        this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
        this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
      }
    }
    $(document).ready(() => {
      $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
    });
  }
  backButtonClicked() {
    this.pageIndex = this.pageIndex - 1;
    if (this.pageIndex == 0) {
      this.titleText = this.oldProcess_Title1;
      this.setDatePickers();
    }
    else {
      this.titleText = this.oldProcess_Title2;
    }
  }
  nextButtonClicked() {
    this.pageIndex = this.pageIndex + 1;
    if (this.pageIndex == 1) {
      this.titleText = this.oldProcess_Title2;
    }
    else {
      this.titleText = this.oldProcess_Title3;
    }
  }
  setDatePickers() {
    $(() => {
      $('#startDatePicker').datepicker({
        clearBtn: true,
        autoclose: true,
        format: "dd/mm/yyyy",
        orientation: "bottom left",
      });
      $('#startDatePicker').on('show', () => {
        if (this.searchForm.controls.startDate.value == null) {
          this.searchForm.controls.startDate.setValue(' ');
        }
      });
      $('#startDatePicker').on('changeDate', () => {
        this.searchForm.controls.startDate.setValue($('#startDatePicker').datepicker('getFormattedDate'));
      });
      $('#startDatePicker').on('hide', () => {
        if (this.searchForm.controls.startDate.value == ' ') {
          this.searchForm.controls.startDate.reset();
        }
        this.searchForm.controls.startDate.markAsTouched();
      });
      $('#endDatePicker').datepicker({
        clearBtn: true,
        autoclose: true,
        format: "dd/mm/yyyy",
        orientation: "bottom left",
      });
      $('#endDatePicker').on('show', () => {
        if (this.searchForm.controls.endDate.value == null)
          this.searchForm.controls.endDate.setValue(' ');
      });
      $('#endDatePicker').on('changeDate', () => {
        this.searchForm.controls.endDate.setValue($('#endDatePicker').datepicker('getFormattedDate'));
      });
      $('#endDatePicker').on('hide', () => {
        if (this.searchForm.controls.endDate.value == ' ') {
          this.searchForm.controls.endDate.reset();
        }
        this.searchForm.controls.endDate.markAsTouched();
      });
    });
  }
  dateControl(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.parent == null) {
      return null;
    }
    let startDateForm = control.parent.get("startDate");
    let endDateForm = control.parent.get("endDate");
    if (startDateForm == null || endDateForm == null) {
      return null;
    }
    if (startDateForm.value != null && startDateForm.value != " " && startDateForm.value != "" && endDateForm.value != null && endDateForm.value != " " && endDateForm.value != "") {
      let dayStart = +startDateForm.value.substr(0, 2);
      let monthStart = +startDateForm.value.substr(3, 2) - 1;
      let yearStart = +startDateForm.value.substr(6, 4);
      let startDate = new Date(yearStart, monthStart, dayStart);
      let dayEnd = +endDateForm.value.substr(0, 2);
      let monthEnd = +endDateForm.value.substr(3, 2) - 1;
      let yearEnd = +endDateForm.value.substr(6, 4);
      let endDate = new Date(yearEnd, monthEnd, dayEnd);
      if (startDate > endDate) {
        return { 'startDateBigger': true };
      }
      else {
        startDateForm.setErrors(null);
        endDateForm.setErrors(null);
      }
    }
    return null;
  }
}
